import NodeStatus from 'features/Integrations/components/NodeStatus/NodeStatus';
import { usePerms } from 'contexts/PermsContext';
import dayjs from 'dayjs';
import { hasDevicePermissionFromDevice } from 'features/Integrations/features/ConnectedSystems/utils/devicePermissions.utils';
import {
  openStageSettings,
  openDeviceSettings,
  openUSGSSettings,
} from 'features/Integrations/state/slices/deviceSlice';
import { DeviceIsSystemType } from 'features/Integrations/utils/deviceComparison.utils';
import { getDeviceIndexMap, getDeviceLicenseInfo } from 'features/Integrations/utils/license.utils';
import { FaCog } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import { useGetConnectedDevicesQuery } from 'services/devices/devices.api';
import { useGetLicenseInfoQuery } from 'services/integrations/integrations.api';
import { getDynamicDeviceIcon } from 'utils/devices/icon.utils';

export const DeviceRowVertical = ({ deviceId, last }) => {
  const { data: connectedDevices = [] } = useGetConnectedDevicesQuery();
  const { data: licenseInfo = {} } = useGetLicenseInfoQuery();
  const perms = usePerms();
  const dispatch = useDispatch();
  const deviceIndex = connectedDevices?.findIndex((device) => device.id === deviceId);

  const device = deviceIndex >= 0 ? connectedDevices[deviceIndex] : null;
  if (!device) return null;
  const deviceIndexMap = getDeviceIndexMap(connectedDevices);
  const license = getDeviceLicenseInfo(device, licenseInfo);
  const deviceIcon = getDynamicDeviceIcon(device, 'img', [30, 30]);
  const canEditDevice = hasDevicePermissionFromDevice(perms, device, 'createEdit');

  const onSettingsClick = (e) => {
    e.stopPropagation();
    if (DeviceIsSystemType(device, 'Flood')) {
      dispatch(openStageSettings(device.id));
    } else if (device.system_type === 'USGS') {
      dispatch(openUSGSSettings(device.id));
    } else {
      dispatch(openDeviceSettings(device.id));
    }
  };

  return (
    <div className={`py-1 ${last ? '' : 'border-bottom border-secondary'}`}>
      <div>
        <div className="d-flex align-items-baseline">
          <div>
            <img src={deviceIcon} alt={device?.device_type || 'Device'} width={'30px'} />
          </div>
          <div>
            <p className="ms-2">
              {device?.alias || device?.monitoring_location_name || device?.name}
            </p>
          </div>
        </div>
      </div>
      {license && (
        <div>
          <p>
            Device Licenses:
            <br />
            {` ${deviceIndexMap.get(device.id)} of ${license.limit} Available`}
          </p>
        </div>
      )}
      <div>
        <p>
          Date Created:
          <br />
          {dayjs(device?.date_created).format('MM/DD/YYYY, hh:mm:ss A')}
        </p>
      </div>
      <div className="d-flex justify-content-center">
        <NodeStatus device={device} />
      </div>
      {canEditDevice && (
        <div className="d-flex justify-content-end" onClick={onSettingsClick}>
          <FaCog size={22} />
        </div>
      )}
    </div>
  );
};
